export const plantsActionTypes = {
	LIST_PLANTS: 'LIST_PLANTS',
	FILTER_PLANT_NAME: 'FILTER_PLANT_NAME',
	FILTER_PLANT_FOR_FORM: 'FILTER_PLANT_FOR_FORM',
};
